import apiConfig from "../config/api";

const apiRoles = `${apiConfig.apiUri}api/accessmanagement/rol`;
const getToken = () => localStorage.getItem("AccessToken");

export const createRol = (idPerfil, name, description, adminAchsOffices) =>
  fetch(`${apiRoles}/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    },
    body: JSON.stringify({
      IdProfile: idPerfil,
      Name: name,
      Description: description,
      AdminAchsOffices: adminAchsOffices
    })
  });

export const updateRol = (id, idPerfil, name, description, adminAchsOffices) =>
  fetch(`${apiRoles}/update`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    },
    body: JSON.stringify({
      Id: id,
      IdProfile: idPerfil,
      Name: name,
      Description: description,
      AdminAchsOffices: adminAchsOffices
    })
  });

export const deleteRol = (idRol) =>
  fetch(`${apiRoles}/delete/${idRol}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  });

export const getRolesByProfile = (idRol) =>
  fetch(`${apiRoles}/get/${idRol}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  });

export const getAllRoles = () =>
  fetch(`${apiRoles}/get/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  });

export const getRolIdByCode = (code) =>
  fetch(`${apiRoles}/get/code/${code}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  })

export const getAllUsersAsch = () =>
  fetch(`${apiConfig.apiUri}api/accessmanagement/assignment/rol/allUsers`, {
  //fetch(`http://localhost:54010/api/accessmanagement/assignment/rol/allUsers`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  })

export const getRolUserSelected = (userId) =>
  fetch(`${apiConfig.apiUri}api/accessmanagement/assignment/rol/getUserRolAchsOffice/${userId}`, {
  //fetch(`http://localhost:54010/api/accessmanagement/assignment/rol/getUserRolAchsOffice?rut=${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  })

  export const getAllRolesByAchs = () =>
  fetch(`${apiConfig.apiUri}api/accessmanagement/rol/get/allAchs/false`, {
  //fetch(`http://localhost:54010/api/accessmanagement/rol/get/allAchs`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    }
  });

export const updateRolWorker = (request) =>
  fetch(`${apiConfig.apiUri}api/accessmanagement/assignment/rol/updateRolAchs`, {
  //fetch(`http://localhost:54010/api/accessmanagement/assignment/rol/updateRolAchs`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "Authorization": `Bearer ${getToken()}`,
    },
    body: JSON.stringify(request)
  });
